import { render, staticRenderFns } from "./keben.vue?vue&type=template&id=0bdbaa55&scoped=true"
import script from "./keben.vue?vue&type=script&lang=js"
export * from "./keben.vue?vue&type=script&lang=js"
import style0 from "./keben.vue?vue&type=style&index=0&id=0bdbaa55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbaa55",
  null
  
)

export default component.exports